import React, { useState, useEffect } from "react";
import "../style/Admin.css";
import { Link } from "react-router-dom";
import logo from "../assets/images/teteklogo-removebg-preview.png";

const Admin = () => {
  const [candidates, setCandidates] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState(null);

  // Fetch candidates from API on component mount
  useEffect(() => {
    fetch("https://assessment.tetekniqx.com/api/employees/")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch candidates");
        return res.json();
      })
      .then((data) => setCandidates(data))
      .catch((err) => console.error(err));
  }, []);

  // const handleViewCandidate = (candidate) => {
  //   setSelectedCandidate(candidate);
  // };

  return (
    <div className="admin__container">
      <header className="admin__header">
        <div className="admin__company-name">
          <img src={logo} alt="Logo" style={{ height: "45px", objectFit: "contain" }} />
        </div>
        <div className="admin__title">Candidate Management</div>
        <button onClick={() => window.open("https://assessment.tetekniqx.com/api/download-pdf/", "_blank")} className="admin__btn admin__btn--primary">
          Download PDF
        </button>
      </header>

      <main className="admin__main-panel">
        {/* Candidate List */}
        {!selectedCandidate && (
          <section id="candidate-list-section" className="admin__section-display">
            <h2 className="admin__section-title">All Candidates</h2>
            <div className="admin__section-content">
              <div className="admin__table-responsive">
                <table className="admin__table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Mobile Number</th>
                      <th>Aptitude</th>
                      <th>Aptitude Result</th>
                      <th>Tech Name</th>
                      <th>Tech Mark</th>
                      <th>Technical Result</th>
                      <th>HR Page</th>
                      
                      
                    </tr>
                  </thead>
                  <tbody>
                    {candidates.length > 0 ? (
                      candidates.map((c) => (
                        <tr key={c.id}>
                          <td>{c.name}</td>
                          <td>{c.number}</td>
                          <td>{c.score}</td>
                           {/* Aptitude Result link */}
                            <td>
                           <Link
                              to={`/results/${c.id}/${c.created_at.split("T")[0]}/aptitude`}
                              className="admin__btn admin__view-candidate-btn"
                            >
                              View
                            </Link>

                            </td>
                          <td>{c.topic}</td>
                          <td>{c.tech_score}</td>
                          <td>
                            <Link
                              to={`/results/${c.id}/${c.created_at.split("T")[0]}/${c.topic}`}
                              className="admin__btn admin__view-candidate-btn"
                            >
                              View
                            </Link>

                          </td>

                          <td>
                       
                          <a href={`/emp-detail/${c.id}`} className="admin__btn admin__view-candidate-btn">
                            For HR
                          </a>
                        

                          </td>
                   
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="11" className="admin__no-data">
                          Loading or no candidates found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        )}

        {/* Candidate Detail View */}
        {selectedCandidate && (
          <section id="candidate-detail-section" className="admin__section-display">
            <h2 className="admin__section-title">
              Candidate Profile: <span>{selectedCandidate.name}</span>
            </h2>
            <div className="admin__section-content">
              <h3 className="admin__section-subtitle">Personal Information</h3>
              <p>
                <strong>ID:</strong> {selectedCandidate.id}
              </p>
              <p>
                <strong>Name:</strong> {selectedCandidate.name}
              </p>
              
              <p>
                <strong>Phone:</strong> {selectedCandidate.number}
              </p>
              <p>
                <strong>Resume:</strong>{" "}
                <a href={selectedCandidate.resume} target="_blank" rel="noopener noreferrer">
                  View PDF
                </a>
              </p>
            </div>

            <div className="admin__section-content">
              <h3 className="admin__section-subtitle">Application & Test Information</h3>
              <p>
                <strong>Applied For:</strong> {selectedCandidate.position_applied}
              </p>
              <p>
                <strong>Application Date:</strong> {selectedCandidate.created_at}
              </p>
              <p>
                <strong>Test Status:</strong> {selectedCandidate.testStatus}
              </p>
              <p>
                <strong>Test Score:</strong> {selectedCandidate.testScore}
              </p>
              <p>
                <strong>Feedback:</strong> {selectedCandidate.feedback}
              </p>
            </div>

            <button
              className="admin__btn admin__btn--secondary"
              onClick={() => setSelectedCandidate(null)}
            >
              Back to List
            </button>
          </section>
        )}
      </main>

      <footer className="admin__footer">© 2025 Vienstereoptic. All rights reserved.</footer>
    </div>
  );
};

export default Admin;
